import { createContext, useContext } from 'react';
import type { ThemePreference, ResolvedTheme } from '../theme/registry';

// Re-export for backward compatibility with existing imports
export type { ThemePreference, ResolvedTheme };

export interface ThemeContextType {
    preference: ThemePreference;
    theme: ResolvedTheme;
    setPreference: (pref: ThemePreference) => void;
}

const ThemeContext = createContext<ThemeContextType>({
    preference: 'light',
    theme: 'light',
    setPreference: () => {},
});

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;
